// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r_VOpkwW7LAj1FcozeC6{align-items:center;border-radius:100px;bottom:6px;display:flex;flex-direction:row;font-family:rubik,helvetica,arial,sans-serif;font-size:14px;font-weight:500;justify-content:center;padding:3px 6px 4px;position:absolute;right:4px}.Epq0zYlyGx86RtYGfk9R{margin-right:3px}.Epq0zYlyGx86RtYGfk9R path{fill:var(--path-fill-color)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `r_VOpkwW7LAj1FcozeC6`,
	"quizSvg": `Epq0zYlyGx86RtYGfk9R`
};
export default ___CSS_LOADER_EXPORT___;
